/* src/app/modules/finanzas/financiacion-privada/financiacion-dialogs.component.css */
.fdl-header-text {
  min-width: 0;
  padding-right: 32px;
}
.fdl-body {
  padding: 0 !important;
}
.fdl-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px;
  background:
    linear-gradient(
      135deg,
      #fbfee8 0%,
      #f4fbd0 100%);
  border-bottom: 1px solid #e5f3a0;
}
.fdl-summary__main {
  display: flex;
  align-items: center;
  gap: 12px;
}
.fdl-summary__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .45);
  display: flex;
  align-items: center;
  justify-content: center;
}
.fdl-summary__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #1a1d23;
}
.fdl-summary__label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #6b7280;
}
.fdl-summary__amount {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #1a1d23;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.fdl-summary__hint {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}
.fdl-section {
  padding: 18px 24px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.fdl-section:last-child {
  border-bottom: none;
  padding-bottom: 18px;
}
.fdl-section .cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.fdl-link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  color: #6b7280;
  cursor: pointer;
}
.fdl-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
.fdl-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0 16px;
}
.fdl-grid__wide {
  grid-column: 1 / -1;
}
.fdl-suffix {
  font-size: 14px;
  color: #6b7280;
  margin-right: 6px;
}
.fdl-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.fdl-alert mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #6b7280;
}
.fdl-alert--error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}
.fdl-alert--error mat-icon {
  color: #dc2626;
}
.fdl-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.fdl-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.fdl-row--editing {
  border-color: #c5d94a;
  background: #fbfee8;
}
.fdl-row__main {
  flex: 1;
  min-width: 0;
}
.fdl-row__amount {
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.fdl-row__meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fdl-row__date {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}
.fdl-row__actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.fdl-row__btn {
  width: 32px;
  height: 32px;
  padding: 4px;
  color: #6b7280 !important;
}
.fdl-row__btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.fdl-row__btn--danger:hover {
  color: #dc2626 !important;
}
.fdl-empty {
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.fdl-upload-input {
  display: none;
}
.fdl-upload-zone {
  grid-template-columns: 1fr;
}
@media (max-width: 600px) {
  .fdl-summary {
    flex-direction: column;
    align-items: flex-start;
  }
  .fdl-row {
    flex-wrap: wrap;
  }
}
/*# sourceMappingURL=financiacion-dialogs.component.css.map */
